import { emersonRoutes } from "@emerson/data/emersonRoutes";

const useWholesalePolicyLink = (): string => {
  return emersonRoutes.account.wholesalePolicy;
};

export { useWholesalePolicyLink };
